import { useMutation, useQueryClient } from 'react-query';
import { EditingStylesApi } from '../../EditingStylesApi';
import { ListEditingStylesQueryKey } from '../../queryKeys';
import { EditingStyle, UpdateEditingStyleInput } from '../../types';

type UpdateEditingStyleArgs = {
    id: number;
    input: UpdateEditingStyleInput;
};

export type UpdateEditingStyle = (id: number, input: UpdateEditingStyleInput) => Promise<EditingStyle>;

export function useUpdateEditingStyleMutation(): UpdateEditingStyle {
    const queryClient = useQueryClient();

    const mutation = useMutation<EditingStyle, unknown, UpdateEditingStyleArgs>(
        ({ id, input }) => EditingStylesApi.updateEditingStyle(id, input),
        {
            onSuccess: () => {
                queryClient.invalidateQueries([ListEditingStylesQueryKey]);
            }
        }
    );

    return function updateEditingStyle(id: number, input: UpdateEditingStyleInput) {
        return mutation.mutateAsync({ id, input });
    };
}
